<template>
  <div class="about__history" id="history">
    <img class="about__history--background" src="https://notaireleveillee.s3.ca-central-1.amazonaws.com/assets/team2.JPG" alt="Notaire outremont">
    <div class="about__history--content">
      <div class="about__history--title">
        <h2>{{ $t("aboutTranslate.aboutHistoryTitle") }}</h2>
        <p>{{ $t("aboutTranslate.aboutHistorySubtitle") }}</p>
      </div>
      <p class="about__history--body">
        {{ $t("aboutTranslate.aboutHistoryBody") }}
      </p>
    </div>
    <div class="about__history--block about__history--block--1"></div>
    <div class="about__history--block about__history--block--2"></div>
  </div>
</template>

<script>
export default {
  name: 'about-history'
}
</script>

<style lang="css">
</style>
